import HomePage from "../containers/Homepage/HomePage";
import LoginPage from "../containers/LoginWall/LoginPage";

export const RoutesWithUserSession = [
    { path: "/sharedbox/:sharedBoxId", element: <HomePage /> },
    { path: "/sharedbox/:sharedBoxId/recipient/:recipientId", element: <HomePage /> },
    { path: "*", element: <HomePage />, },
];

export const PublicRoutes = [
    { path: "/sharedbox/:sharedBoxId", element: <LoginPage /> },
    { path: "/sharedbox/:sharedBoxId/recipient/:recipientId", element: <LoginPage /> },
    { path: "*", element: <LoginPage /> },
];

export default RoutesWithUserSession;